import withStyles from '@material-ui/core/styles/withStyles';
import default_img from "assets/img/image_placeholder.jpg";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { default as React } from 'react';
import { connect } from 'react-redux';
import { t } from 'i18next';

// A long survey intro is fine on desktop but hurts the mobile experience — the guest has to
// scroll past a wall of text before the first question. So on phones (<=600px) a long intro is
// collapsed behind a "Read more" toggle; on desktop it always shows in full, unchanged.
const MOBILE = '@media (max-width: 600px)';
const LONG_INTRO = 160; // chars — below this the intro is short enough to always show

const styles = {
    // Desktop keeps the original layout: the sm={2} column caps the logo. On a phone that column
    // becomes full-width, so a squarish hotel logo filled the entire first screen and the guest saw
    // no question at all without scrolling. Compact header instead: small centred logo, small
    // centred title, tight margins — everything on one glance, like the desktop proportions.
    surveyImg: {
        width: "100%",
        [MOBILE]: {
            width: 'auto',
            maxWidth: '80%',
            maxHeight: 110,
            display: 'block',
            margin: '0 auto',
        }
    },
    surveyTitle: {
        [MOBILE]: {
            fontSize: 17,
            margin: '8px 0 2px',
        }
    },
    introText: {
        [MOBILE]: { textAlign: 'center' }
    },
    compactCard: {
        [MOBILE]: { marginTop: 10, marginBottom: 10 }
    },
    compactBody: {
        [MOBILE]: { padding: '10px 15px' }
    },
    // Desktop: always visible. Mobile: hidden until the guest taps "Read more".
    descCollapsedMobile: {
        [MOBILE]: { display: 'none' }
    },
    // Toggle button — only shown on mobile (and only when the intro is long).
    mobileToggle: {
        display: 'none',
        [MOBILE]: {
            display: 'inline-block',
            background: 'none',
            border: 'none',
            color: '#2f8a45',
            fontFamily: 'inherit',
            fontSize: 14,
            fontWeight: 600,
            padding: '4px 0',
            cursor: 'pointer',
        }
    },
};

class SurveyMainComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { expanded: false };
    }
    render() {
        const { classes } = this.props;
        let data = this.props.data;
        if (!data.image_url || data.image_url.length < 3) {
            data.image_url = default_img
        }
        const desc = data.description || '';
        const isLong = desc.length > LONG_INTRO;
        const { expanded } = this.state;
        // Short intro → always visible. Long intro → visible on desktop always, on mobile only
        // once expanded (the descCollapsedMobile class hides it on phones until then).
        const descClass = (!isLong || expanded) ? '' : classes.descCollapsedMobile;
        return <Card className={classes.compactCard}>
            <CardBody className={classes.compactBody}>
                <GridContainer>
                    <GridItem sm={2} xs={12}>
                        <img className={classes.surveyImg} src={data.image_url} />
                    </GridItem>
                    <GridItem sm={10} xs={12} className={classes.introText}>
                        <h3 className={classes.surveyTitle}><b>{data.title}</b></h3>
                        {isLong &&
                            <button type="button" className={classes.mobileToggle}
                                onClick={() => this.setState({ expanded: !expanded })}>
                                {expanded
                                    ? t('Show less', { lng: data.language }) + ' ▴'
                                    : t('Read more', { lng: data.language }) + ' ▾'}
                            </button>}
                        <p className={descClass}>{desc}</p>
                    </GridItem>
                </GridContainer>
            </CardBody>
        </Card>
    }
}
const mapStatsToProps = ({ user }) => ({ user });
export default connect(mapStatsToProps)(
    withStyles(styles, { withTheme: true })(SurveyMainComponent)
);
